<script>
export default
{
	name: 'topoCPCliente',
	props: { cprotasobre: String, cprotaresgate: String },
	data() { return {
		topoCPInfo: {
			cpExpirada: true,
            rotaCPSobre: this.cprotasobre,
            rotaCPResgate: this.cprotaresgate
			},
			root: ROOT_URL,
			app: APP_URL
		}
	},
	methods: {
		checkValidadeCPCliente()
		{
            this.axios.get(API_URL + '/campanha-pontos/expiracao-campanha-pontos-cliente-api').then((dadosExpiracaoCPInfo) => {
                this.topoCPInfo.cpExpirada = dadosExpiracaoCPInfo.data.campanhaPontosExpirada;
            });
		}
	},
	mounted() {
		this.checkValidadeCPCliente();
	}
}
</script>